/* eslint-disable no-console */

import { useStore } from '@/store';
import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
	register(`${process.env.BASE_URL}service-worker.js`, {
		ready() {
			console.log('App is being served from cache by a service worker.');
			const store = useStore();
			store.swStatus = {
				...store.swStatus,
				registered: true,
				ready: true
			};
		},
		registered(registration) {
			registration.installing?.postMessage({ type: 'GET_APP_PROGRESS' });
			console.log('Service worker has been registered.');
			const store = useStore();
			store.swStatus = {
				...store.swStatus,
				registered: true
			};
		},
		cached() {
			console.log('Content has been cached for offline use.');
			const store = useStore();
			store.swStatus = {
				...store.swStatus,
				contentCached: true,
				updating: false
			};
		},
		updatefound() {
			console.log('New content is downloading.');
			const store = useStore();
			store.swStatus = {
				...store.swStatus,
				updating: true,
				appDownload: null
			};
		},
		updated() {
			console.log('New content is available; please refresh.');
			const store = useStore();
			store.serviceWorkerUpdate = true;
			store.swStatus = {
				...store.swStatus,
				updateAvailable: true,
				updating: false
			};
		},
		offline() {
			console.log('No internet connection found. App is running in offline mode.');
			const store = useStore();
			store.swStatus = {
				...store.swStatus,
				isOffline: true
			};
		},
		error(error) {
			console.error('Error during service worker registration:', error);
			const store = useStore();
			store.swStatus = {
				...store.swStatus,
				errorMsg: error?.message || String(error),
				error: true
			};
		}
	})
}
